import { render, staticRenderFns } from "./ImpresionBoletosReserva.vue?vue&type=template&id=7756487e&"
import script from "./ImpresionBoletosReserva.vue?vue&type=script&lang=js&"
export * from "./ImpresionBoletosReserva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports